import React, { Component } from 'react';
import DurexIcon from '../DurexIcon/DurexIcon';

import classes from './SplashScreen.css';

class SplashScreen extends Component {

	onHover = () => {
		this.className={};
	}

	

	render () {
		return (
			<div className={classes.SplashHolder}>
				<img
				src='./durex-logo-splash.png'
				alt='Durex Love Sex'
				className={classes.SplashLogoHolder}
				/>
				<DurexIcon 
					svg={"./sprites/coffee.svg"} 
					img={"./sprites/coffee.png"} 
					x={15} y={12} size={9}
				/>
				<DurexIcon 
					svg={"./sprites/mouth.svg"} 
					img={"./sprites/mouth.png"} 
					x={5} y={32} size={10}
				/>
				<DurexIcon 
					svg={"./sprites/headphones.svg"} 
					img={"./sprites/headphones.png"} 
					x={20} y={35} size={7}
				/>
				<DurexIcon 
					svg={"./sprites/bluecondom.svg"} 
					img={"./sprites/bluecondom.png"} 
					x={30} y={18} size={11}
				/>
				<DurexIcon 
					svg={"./sprites/hand.svg"} 
					img={"./sprites/hand.png"} 
					x={58} y={15} size={6}
				/>
				<DurexIcon 
					svg={"./sprites/malesign.svg"} 
					img={"./sprites/malesign.png"} 
					x={65} y={23} size={10}
				/>
				<DurexIcon 
					svg={"./sprites/pinkcondom.svg"} 
					img={"./sprites/pinkcondom.png"} 
					x={78} y={15} size={10}
				/>
				<DurexIcon 
					svg={"./sprites/notebook.svg"} 
					img={"./sprites/notebook.png"} 
					x={72} y={42} size={14}
				/>
				<DurexIcon
					svg={"./sprites/malefemalesign.svg"} 
					img={"./sprites/malefemalesign.png"} 
					x={63} y={48} size={6}
				/>
				<DurexIcon
					svg={"./sprites/hearts.svg"} 
					img={"./sprites/hearts.png"} 
					x={65} y={65} size={14}
				/>
				<DurexIcon
					svg={"./sprites/purplecondom.svg"} 
					img={"./sprites/purplecondom.png"} 
					x={80} y={75} size={7}
				/>
				<DurexIcon
					svg={"./sprites/sneakers.svg"} 
					img={"./sprites/sneakers.png"} 
					x={55} y={65} size={7}
				/>
				<DurexIcon
					svg={"./sprites/redcondom.svg"} 
					img={"./sprites/redcondom.png"} 
					x={38} y={65} size={8}
				/>
				<DurexIcon
					svg={"./sprites/femalesign.svg"} 
					img={"./sprites/femalesign.png"} 
					x={30} y={50} size={7}
				/>
				<DurexIcon
					svg={"./sprites/love.svg"} 
					img={"./sprites/love.png"} 
					x={10} y={55} size={9}
				/>
				<DurexIcon
					svg={"./sprites/yellowcondom.svg"} 
					img={"./sprites/yellowcondom.png"} 
					x={23} y={70} size={8}
				/>

				<img
				src='./splash-title.png'
				alt=''
				className={classes.SplashText}
				/>

			</div>
		);
	}
};

export default SplashScreen;


// WEBPACK FOOTER //
// ./src/components/SplashScreen/SplashScreen.js